import type { TOffer } from 'shared/types/TRankingService';

// если общий статус поллинга COMPLETE, но данные по офферу так и не пришли, то такой оффер нужно отфильтровать
export const filterOffersByPreApprovingStatus = (offers: TOffer[], status: string) => {
  if (status === 'complete') {
    return offers.filter((offer) => !offer?.additionalInfo?.isPreapproving);
  }
  return offers;
};
